import ThothV2 from '../base/thothV2';

class ProfileMonitoringService extends ThothV2 {
    getParameters() {
        return this.fetch({
            url: '/assignors-monitoring/parameters',
        });
    }

    createRule(data) {
        return this.fetch({
            url: '/assignors-monitoring/rules',
            method: 'POST',
            data,
        });
    }

    updateRule(ruleId, data) {
        return this.fetch({
            url: `/assignors-monitoring/rules/${ruleId}`,
            method: 'PUT',
            data,
        });
    }

    deleteRule(ruleId, actor) {
        return this.fetch({
            url: `/assignors-monitoring/rules/${ruleId}`,
            method: 'DELETE',
            headers: actor ? { 'x-user': actor } : undefined,
        });
    }

}

export default new ProfileMonitoringService();
